import { Link } from 'react-router'
import { Button } from '#app/components/ui/button'

interface SignUpButtonProps {
	variant?: 'default' | 'outline'
	className?: string
	children?: React.ReactNode
	size?: 'default' | 'sm' | 'lg' | 'xl'
}

export function SignUpButton({
	variant = 'default',
	className,
	children,
	size,
}: SignUpButtonProps) {
	return (
		<Button variant={variant} className={className} size={size} asChild>
			<Link to="/sign-up">{children || 'Sign Up'}</Link>
		</Button>
	)
}
